import React, { useState } from 'react';

import './App.css';

import Gifts from './Gifts';
import Pledges from './Pledges';
import CashRevenue from './CashRevenue';
import { withAuthenticator, Button, Heading } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import logo from './assets/IndividualGivingLogo.png';

function App({ signOut, user }) {
  const [content, setContent] = useState('gifts')
  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setContent(selectedValue)
  }
  const renderContent = () => {
    switch (content) {
      case 'gifts':
        return <Gifts user={user} styles={styles} />;
      case 'pledges':
        return <Pledges user={user} styles={styles} />;
      case 'cash-revenue':
        return <CashRevenue user={user} />;
      default:
        return <Gifts user={user} styles={styles} />;
    }
  };
  return (
    <div className="App">
      <header style={styles.header}>
        <img src={logo} alt="Individual Giving Logo" />
        <nav>
          <div style={styles.selectContainer}>
            <select onChange={handleDropdownChange} aria-label="Select Page" style={styles.select}>
              <option value="gifts">Gifts</option>
              <option value="pledges">Open Pledges</option>
              <option value="cash-revenue">Gift Type Designations</option>
            </select>
          </div>
        </nav>
        <Heading level={5} style={styles.userEmail}>Hello {user.attributes.email}</Heading>
        <Button level={3} onClick={signOut}>Sign out</Button>
      </header>
      <main>
        <section>
          <div>{renderContent()}</div>
        </section>
      </main>
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    width: '80%',
    margin: '0 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    position: 'absolute',  
    top: '10px',           
    left: '10px',          
    width: '160px',        // Adjusted the width here
    zIndex: 10,            
  },
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // To spread out the email and button
    padding: '20px 50px',
  },
  userEmail: {
    textAlign: 'center',  // Center align the text of the email
    flex: 1,  // Take up available space to push the button to the right
  },
  instructionsContainer: {
    padding: '20px',
    textAlign: 'left',
    margin: '0 auto',
    maxWidth: '1000px',
    width: '100%'
  },
  instructionText: {
    marginBottom: '20px',
  },
  todo: { marginBottom: 15 },
  input: { border: 'none', backgroundColor: '#ddd', marginBottom: 10, padding: 8, fontSize: 18 },
  todoName: { fontSize: 20, fontWeight: 'bold' },
  todoDescription: { marginBottom: 0 },
  button: { backgroundColor: 'black', color: 'white', outline: 'none', fontSize: 18, padding: '12px 0px' },
  image: {
    width: '100%',  // Reducing the width to 60% will make the image 40% smaller
    display: 'block',  // To center the image if it's smaller than its container
    margin: '0 auto'
  },
}

export default withAuthenticator(App);